import { Directive, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Directive({
  standalone: false,
})
export abstract class OnDestroyHookDirective implements OnDestroy {
  private subscriptions: Subscription[] = [];

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      if (subscription && subscription.unsubscribe) {
        subscription.unsubscribe();
      }
    });
    this.subscriptions = [];
  }

  addSubscription = (...subscriptions: Subscription[]) => {
    subscriptions.forEach((sub) => this.subscriptions.push(sub));
  };
}
